// Currency catalog + helpers. Ported from CRM 2.0. Org-wide default is set in
// Settings → General; per-lead override is supported via lead.currency. Symbols
// are baked in here rather than relying on Intl.NumberFormat so we get the same
// visual across tables / drawers / dashboards.

export const CURRENCIES = [
  { code: "USD", symbol: "$",     label: "US Dollar" },
  { code: "INR", symbol: "₹",     label: "Indian Rupee" },
  { code: "EUR", symbol: "€",     label: "Euro" },
  { code: "GBP", symbol: "£",     label: "British Pound" },
  { code: "JPY", symbol: "¥",     label: "Japanese Yen" },
  { code: "CAD", symbol: "C$",    label: "Canadian Dollar" },
  { code: "AUD", symbol: "A$",    label: "Australian Dollar" },
  { code: "SGD", symbol: "S$",    label: "Singapore Dollar" },
  { code: "AED", symbol: "د.إ",   label: "UAE Dirham" },
  { code: "CNY", symbol: "¥",     label: "Chinese Yuan" },
  { code: "CHF", symbol: "Fr",    label: "Swiss Franc" },
  { code: "ZAR", symbol: "R",     label: "South African Rand" },
  { code: "BRL", symbol: "R$",    label: "Brazilian Real" },
  { code: "MXN", symbol: "Mex$",  label: "Mexican Peso" },
];

export const DEFAULT_CURRENCY = "USD";
export const CURRENCY_CODES = CURRENCIES.map((c) => c.code);

export function getCurrencySymbol(code) {
  const found = CURRENCIES.find((c) => c.code === code);
  return found ? found.symbol : "$";
}

export function formatCurrency(value, code = DEFAULT_CURRENCY) {
  const symbol = getCurrencySymbol(code);
  if (value === null || value === undefined || value === "") return null;
  if (typeof value === "string") {
    if (value.startsWith(symbol)) return value;
    const numeric = Number(value);
    if (Number.isFinite(numeric)) return `${symbol}${numeric.toLocaleString()}`;
    return `${symbol}${value}`;
  }
  if (!Number.isFinite(value)) return null;
  return `${symbol}${value.toLocaleString()}`;
}

export function formatCurrencyCompact(value, code = DEFAULT_CURRENCY) {
  const symbol = getCurrencySymbol(code);
  if (!value && value !== 0) return "0";
  if (value >= 1_000_000) return `${symbol}${(value / 1_000_000).toFixed(1)}M`;
  if (value >= 1_000) return `${symbol}${(value / 1_000).toFixed(1)}K`;
  return `${symbol}${value.toLocaleString()}`;
}

export function currencyOption(code) {
  const c = CURRENCIES.find((x) => x.code === code);
  if (!c) return { value: code, label: code };
  return { value: c.code, label: `${c.symbol}  ${c.code} — ${c.label}` };
}

export const CURRENCY_OPTIONS = CURRENCIES.map((c) => currencyOption(c.code));
